import { supabase } from './supabase'

export const getPublicImageUrl = (bucket: string | null | undefined, key: string | null | undefined) => {
  if (!bucket || !key) {
    return ''
  }

  const { data } = supabase.storage.from(bucket).getPublicUrl(key)

  return data?.publicUrl ?? ''
}
